import Swiper, { Navigation } from 'swiper';
import { loader } from '../utils/loader';

/**
 * Hero
 */
class Hero {
	/**
	 * Construct
	 *
	 * @description set state and cache elements.
	 */
	constructor(element) {
		/* Queries */
		this.element = element;

		if (!this.element) {
			return;
		}

		/* Initilize */
		this.init();
	}

	/**
	 * Init
	 *
	 * @description initialize.
	 */
	init() {
		const swiper = new Swiper(this.element, {
			modules: [Navigation],
			slidesPerView: 1,

			// Navigation arrows
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	}
}

/**
 * Create Hero
 */
export const createHero = () => {
	loader('.rx-hero', Hero);
};
